import {
  Dialog as HeadlessDialog,
  DialogPanel,
  DialogTitle,
  DialogBackdrop,
} from '@headlessui/react'
import { ReactNode } from 'react'
import { Text } from '@/components'
import { XIcon } from 'lucide-react'

type Props = {
  isOpen: boolean
  title: string
  onClose: () => void
  children?: ReactNode
}
export default function Dialog({ isOpen, title, onClose, children }: Props) {
  return (
    <HeadlessDialog
      open={isOpen}
      as="div"
      className="relative z-10 focus:outline-none"
      onClose={onClose}
    >
      <DialogBackdrop className="fixed inset-0 bg-black/30" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel
          transition
          className="w-full max-w-lg rounded-xl bg-white p-6 shadow-xl transition-all duration-100 ease-out data-[closed]:transform-[scale(95%)] data-[closed]:opacity-0"
        >
          <DialogTitle
            as="div"
            className={'flex items-center justify-between gap-2 mb-4'}
          >
            <Text variant="subheader">{title}</Text>
            <button
              onClick={onClose}
              className="rounded-full p-2 hover:bg-gray-100 bg-transparent border-none flex items-center cursor-pointer"
            >
              <XIcon size={20} className="flex-none" />
            </button>
          </DialogTitle>
          {children}
        </DialogPanel>
      </div>
    </HeadlessDialog>
  )
}
